import React from 'react';
import PropTypes from 'prop-types';

import format from 'date-fns/format';

import {
    Flex,
    Text,
} from '@zillow/constellation';

import {
    Col,
    Row,
} from '@zillow/zrs-comet';

import {
    StyledContainer,
} from './StyledComponents';

const propTypes = {
    listing: PropTypes.shape({
        active: PropTypes.bool.isRequired,
        views: PropTypes.number.isRequired,
        numLeadsSinceLastActivated: PropTypes.number.isRequired,
        dateLastActivatedTimestamp: PropTypes.number,
        expirationDateTimestamp: PropTypes.number,
    }).isRequired,
};

const ListingStat = ({
    title,
    content,
}) => (
    <Flex flex="1" display="flex" flexDirection="column" alignItems="center">
        <Text as="div" fontType="bodySmall">{title}</Text>
        <Text as="div" fontType="bodyHeading">{content}</Text>
    </Flex>
);

const ListingStats = ({
    listing,
}) => {
    const dateTimestamp = Number(!listing.active
        ? listing.expirationDateTimestamp
        : listing.dateLastActivatedTimestamp);
    const formattedDate = isNaN(dateTimestamp) ? '-' : format(new Date(dateTimestamp), 'MMM DD YYYY');
    return (
        <Row paddingY="xs">
            <Col>
                <StyledContainer>
                    <ListingStat title={listing.active ? 'Published' : 'Deactivated'} content={formattedDate} />
                    <ListingStat title="Contacts" content={listing.numLeadsSinceLastActivated || '-'} />
                    <ListingStat title="Views" content={listing.views || '-'} />
                </StyledContainer>
            </Col>
        </Row>
    );
};

ListingStats.propTypes = propTypes;

export { ListingStats };
export default ListingStats;
